// extracted by mini-css-extract-plugin
export default {"skeletonRectangle":"LNzSEQ","fullWidthColumn":"OG14el","gradientFill":"TSaWAi"};